/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Grid, Box, Typography, IconButton } from '@mui/material';
import './CustomModal.css';
import { fonts, themes } from '../../themes/themes';
import { useTranslate } from '../../../hooks';
interface ModalProps {
  modal: {
    modal_title?: string | ReactNode;
  };
  closeModal: any;
  onClickBack?: any;
  showDownloadButton?: boolean;
  onDownload?: any;
  fontSize?: any;
  fontWeight?: any;
  wrap?: any;
}

const ModalHeader = ({
  modal,
  closeModal,
  showDownloadButton = false,
  onDownload,
  fontSize = fonts.header,
  fontWeight = 'bold',
  wrap
}: ModalProps) => {
  const { isRTL } = useTranslate();

  return (
    <Grid
      container
      xs={12}
      sx={{
        marginBottom: '1em',
        display: 'flex',
      }}
    >
      {showDownloadButton ? (
        <>
          <Grid item xs={10}></Grid>
          <Grid
            item
            xs={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              fontFamily: fonts.fontFamily,
            }}
          >
            <Box className="icon-box-clockIn">
              <IconButton>
                <i className="las la-cloud-download-alt" onClick={onDownload} />
              </IconButton>
            </Box>
          </Grid>
          <Grid
            item
            xs={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Box className="icon-box-clockIn">
              <IconButton>
                <i className="las la-times" onClick={() => closeModal()} />{' '}
              </IconButton>
            </Box>
          </Grid>
        </>
      ) : (
        <>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              fontFamily: fonts.fontFamily,
            }}
          >
            <Box
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                maxWidth: 'fitContent',
                alignItems: 'center',
              }}
            >
              <i
                className={
                  isRTL ? 'las la-arrow-right mx-1' : 'las la-arrow-left mx-1'
                }
                style={{
                  color: '#8181A5',
                  fontSize: '20px',
                  cursor: 'pointer',
                }}
                onClick={() => closeModal()}
              />
            </Box>
            <Typography
              style={{
                fontSize: fontSize,
                color: themes.editCardHeader_blue,
                fontWeight: fontWeight,
                textWrap: wrap
              }}
            >
              {modal.modal_title}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Box className="icon-box-clockIn">
              <i
                className="las la-times"
                style={{
                  fontSize: '16px',
                  color: themes.blackDefault,
                }}
                onClick={() => closeModal()}
              />{' '}
            </Box>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ModalHeader;
